import { GraphItem } from "./graphItem";
import { Text } from "../text/text";

import styles from  "./graph.module.css"

export const Graph = ({ title, items, height }) => {
    const preparedItems = [];
    let maxValue = items[0]?.value;
    let minValue = items[0]?.value;
    let averageValue = 0;

    for (const item of items) {
        averageValue += item.value;

        if (item.value > maxValue) {
            maxValue = item.value;
        }

        if (item.value < minValue) {
            minValue = item.value;
        }

        preparedItems.push({
            value: Number(item.value),
            date: new Date(item.date)
        })
    }

    if (items.length) {
        averageValue /= items.length;
    }
    const midStart = averageValue - (averageValue - minValue) * 0.25;
    const midEnd = averageValue + (maxValue - averageValue) * 0.25;

    return (
        <div className={styles.graph_container} style={{ height }}>
            <Text as="div" variant="h3" className={styles.graph_title} size={16} weight={700} lineHeight="1.1">
                {title}
            </Text>
            <div className={styles.graph_items}>
                {
                    preparedItems.sort((a, b) => a.date.getTime() - b.date.getTime()).map((data, i) =>
                        <GraphItem
                            key={i}
                            height={data.value / maxValue}
                            value={data.value}
                            date={data.date}
                            type={(data.value < midStart) ? "low" : (data.value > midEnd) ? "high" : "mean"}
                        />
                    )
                }
            </div>
        </div>
    );
}